module.exports = __webpack_public_path__ + "img/scan-QR-code.7aecd746.png";